// note: overriding linting to use quick access to local storage for UI preferences
/* eslint-disable no-storage/no-browser-storage */

'use client';

import { isServer } from '@frameio/utils';
import type { ThemeSizing } from '@frameio/vapor';
import { appComponentsStorage } from '../../storage';

const SIZING_VALUES: ReadonlyArray<ThemeSizing> = [
  'small',
  'regular',
  'large',
] as const;

/**
 * Get the UI sizing preference from local storage
 * @param fallback - the fallback sizing to use if local storage is not available
 */
export const getLocalSizingPreference = (
  fallback: ThemeSizing = 'regular'
): ThemeSizing => {
  if (isServer) return fallback;

  try {
    const stored = appComponentsStorage.get('frame-io--ui-sizing-preference');
    if (stored && SIZING_VALUES.includes(stored)) {
      return stored;
    }
    return fallback;
  } catch (e) {
    return fallback;
  }
};

/**
 * Set the UI sizing preference in local storage
 * @param value - the sizing value to set in local storage
 */
export const setLocalSizingPreference = (value: ThemeSizing): void => {
  if (isServer) return;

  try {
    if (SIZING_VALUES.includes(value)) {
      appComponentsStorage.set('frame-io--ui-sizing-preference', value);
    }
  } catch (e) {
    // unsupported
  }
};
